import { render, staticRenderFns } from "./mdBackQueryShAction.vue?vue&type=template&id=ba87b2da&scoped=true"
import script from "./mdBackQueryShAction.vue?vue&type=script&lang=js"
export * from "./mdBackQueryShAction.vue?vue&type=script&lang=js"
import style0 from "./mdBackQueryShAction.vue?vue&type=style&index=0&id=ba87b2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba87b2da",
  null
  
)

export default component.exports